module.exports = __webpack_public_path__ + "assets/manual_payments-52d7debdb4a1c4720ff074b78ef4a3f3.pdf";